var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"C-category-info__handler"},[_c('i',{staticClass:"C-bubble-holder",domProps:{"innerHTML":_vm._s(require(`!!html-loader!@root/assets/svg/bubble-holder.svg`))}}),_vm._v(" "),_c('button',{on:{"click":_vm.scrollToElement}},[_c('i',{staticClass:"fas fa-chevron-down C-bounce"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }